// Central Chart.js v3 registration.
// Chart.js v3 is tree-shakeable and react-chartjs-2 v3 no longer auto-registers
// controllers/elements/scales, so we register everything here once and import
// this module early (see src/index.js).
import { Chart as ChartJS, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(...registerables, ChartDataLabels);

// Preserve the previous global defaults that used to live in
// MediaAnalyticDashboard (Chart.defaults.global.legend.*).
ChartJS.defaults.plugins.legend.display = true;
ChartJS.defaults.plugins.legend.position = 'bottom';

export default ChartJS;
